export const HOUSE_NUMBER_RANGE_REGEX: RegExp = /^[1-9]\d*(?:[ -]?(?:[1-9]\d*))?$/g
